import orderBy from "lodash/orderBy";
import { isEmpty, isNull } from "lodash/lang";
import without from "lodash/without";
import take from "lodash/take";
import takeRight from "lodash/takeRight";
import uniqBy from "lodash/uniqBy";
import findIndex from "lodash/findIndex";
import pullAt from "lodash/pullAt";
import find from "lodash/find";
import filter from "lodash/filter";
import includes from "lodash/includes";
import min from "lodash/min";
import map from "lodash/map";
import remove from "lodash/remove";
import isEqual from "lodash/isEqual";
import last from "lodash/last";
import uniq from "lodash/uniq";
import debounce from "lodash/debounce";
import slice from "lodash/slice";
import union from "lodash/union";
import { nanoid } from "nanoid";
import cloneDeep from "lodash/cloneDeep";
import delay from "lodash/delay";
import omit from "lodash/omit";

export const DataUtility = {
  orderBy,
  isEmpty,
  without,
  take,
  takeRight,
  uniqBy,
  findIndex,
  pullAt,
  find,
  filter,
  includes,
  isNull,
  min,
  map,
  remove,
  isEqual,
  last,
  uniq,
  debounce,
  slice,
  union,
  nanoid,
  cloneDeep,
  delay,
  omit
};
